const createUrl = (url, replacements = {}) => {
  let createdUrl = url
  Object.keys(replacements).forEach(
    (key) => (createdUrl = createdUrl.replace(`:${key}`, replacements[key])),
  )
  return createdUrl
}

export default createUrl
